import { render, staticRenderFns } from "./VAppMain.vue?vue&type=template&id=f9e0ae18&"
import script from "./VAppMain.vue?vue&type=script&lang=ts&"
export * from "./VAppMain.vue?vue&type=script&lang=ts&"
import style0 from "./VAppMain.vue?vue&type=style&index=0&id=f9e0ae18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports